import moment from 'dayjs';
import numeral from 'numeral';

import { currencies } from '@/common/dictionary.js';

function showEmtpy() {
	return '-';
}

const filters = {
	isEmpty: function (val) {
		return val === undefined || val === '' || val === null || val === -1 ? '-' : val;
	},
	dataListFormat: function (val, format = 'isEmpty', row) {
		if (!format) {
			return val;
		}
		if (typeof format == 'function') {
			return filters[format()](val);
		} else if (typeof format == 'object') {
			let funName = format.funName;
			let type = row ? row[format.paramProp] : undefined;
			if (!type) {
				type = '';
			}
			return filters[funName](val, type);
		} else {
			return filters[format](val);
		}
	},
	currency(value, type) {
		let mapping = {
			127001: 'rmb',
			127002: 'usd',
			127003: 'hk',
		};
		return filters[mapping[type]](value);
	},
	custom: function (val, formatter) {
		return val != null && val != undefined ? numeral(val).format(formatter) : showEmtpy();
	},
	usd: function (val) {
		return val != null && val != undefined ? numeral(val).format('$0,0.00') : showEmtpy();
	},
	rmb: function (val) {
		return val != null && val != undefined
			? `￥${numeral(val).format('0,0.00')}`
			: `￥${numeral(0).format('0,0.00')}`;
	},
	hk: function (val) {
		return val != null && val != undefined ? 'HK$' + numeral(val).format('0,000.00') : showEmtpy();
	},

	date: function (val, format) {
		if (val) {
			return moment(val).format(format || 'YYYY-MM-DD');
		} else {
			return showEmtpy();
		}
	},

	time: function (val, format) {
		if (val) {
			return moment(val).format(format || 'h:mm:ss');
		} else {
			return showEmtpy();
		}
	},

	percent: function (val) {
		if (val) {
			return numeral(val).format('0.00%');
		} else {
			return showEmtpy();
		}
	},
	pct: function (val) {
		if (val) {
			return numeral(val).format('0%');
		} else {
			return showEmtpy();
		}
	},
	jojint(val) {
		if (val || val == 0) {
			return val + '%';
		} else {
			return showEmtpy();
		}
	},
	jojintAbs(val) {
		if (val || val == 0) {
			if (val > 0 || val == 0) {
				return `${val}%`;
			} else {
				return `${Math.abs(val)}%`;
			}
		} else {
			return showEmtpy();
		}
	},
	number: function (val) {
		if (val || val === 0) {
			return numeral(val).format('0,000.00');
		} else {
			return showEmtpy();
		}
	},
	thousands: function (val) {
		if (val || val === 0) {
			return numeral(val).format('0,000');
		} else {
			return showEmtpy();
		}
	},
	getweek: function (val) {
		if (val) {
			return moment(val).format('YYYY/MM/DD h:mm:ss');
		} else {
			return showEmtpy();
		}
	},
	getday: function (val) {
		//获取星期几
		var weekDays = ['星期天', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
		if (val) {
			return weekDays[moment(val).format('d')];
		} else {
			return showEmtpy();
		}
	},
	days: function (val) {
		//获取天数
		if (val) {
			return moment(val).format('Do').split('th')[0] + '日';
		} else {
			return showEmtpy();
		}
	},
	connectRange(val1, val2) {
		return `${val1} - ${val2}`;
	},
	moneyRange(data) {
		if (data.length != 0) {
			if (data[1] == -1) {
				return '￥' + numeral(data[0]).format('0,0.00') + '+';
			} else if (data[0] == -1) {
				return '￥' + numeral(data[1]).format('0,0.00') + '-';
			}
			return '￥' + numeral(data[0]).format('0,0.00') + ' ~ ￥' + numeral(data[1]).format('0,0.00');
		} else {
			return showEmtpy();
		}
	},
	hideMobile(val) {
		if (val) {
			return val.replace(/(\d{3})(\d{4})/, '$1****');
		}
		return showEmtpy();
	},
	hideTel(val) {
		if (val) {
			return val.replace(/(\d{4})$/, '****');
		}
		return showEmtpy();
	},
	// 返回{货币符号+价格+（货币中文名）}
	money(price, currency, isLabel, onlySymbol) {
		let currencieItem = currencies.find(item => item.value == currency);

		let { label, symbol } = currencieItem;
		if (onlySymbol) return symbol;
		if (isLabel && currency !== 127001)
			return `${symbol} ${numeral(price).format('0,0.00')} (${label})`;
		return `${symbol} ${numeral(price).format('0,0.00')}`;
	},
};
export default {
	filters: filters,
};
